import { APIService } from "../Service/API.Service";
import type { CCMessageItem } from "./ContactCenterV3.API";

interface TranscriptAccessResponse {
  orgId: number;
  userId: number;
  userName: string;
  locationName: string;
  locationAddress: string;
  channels: { channel: string; botConversationId: number; summary: string; messages: CCMessageItem[] }[];
}

// LINK apps/server/src/API/ContactCenterV3/ContactCenterV3.Controller.ts (access/{token} route)
// Token-gated, anonymous — the current session, whichever channels it spans.
export class ContactCenterV3AccessAPI {
  static async getTranscript(token: string) {
    return APIService.Server.get<TranscriptAccessResponse>(`/contact-center-v3/access/${token}/conversation`);
  }
}
